import type { User } from "firebase/auth";
import {
  getAuth,
  signOut as signOutFunc,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithEmailAndPassword as signInWithEmailAndPasswordFunc,
  createUserWithEmailAndPassword as createUserWithEmailAndPasswordFunc,
  sendEmailVerification as sendEmailVerificationFunc,
} from "firebase/auth";

import reduxStorage from "@/storage";

import cookies, { COOKIE_NAME } from "@/cookies";
import app from "./app";

export const auth = getAuth(app);

export const signOut = async () => {
  await signOutFunc(auth);
  await reduxStorage.clear();
  cookies.remove(COOKIE_NAME);
};

const googleAuthprovider = new GoogleAuthProvider();

export const signInWithGooglePopup = () =>
  signInWithPopup(auth, googleAuthprovider);

export const signInWithEmailAndPassword = (email: string, password: string) =>
  signInWithEmailAndPasswordFunc(auth, email, password);
export const createUserWithEmailAndPassword = (
  email: string,
  password: string,
) => createUserWithEmailAndPasswordFunc(auth, email, password);

export const sendEmailVerification = (user?: User) =>
  sendEmailVerificationFunc(user ?? auth.currentUser!);

export const reloadUser = () => auth.currentUser && auth.currentUser.reload();
